export enum LabelEntityType {
	PART = 'PART',
	ASSET = 'ASSET',
}

export type Label = {
	id: number;
	label: string;
	color: string;
	associatedPartsCount?: number;
	associatedAssetsCount?: number;
};

export type LabelOption = {
	label: string;
	value: string;
};

export type CreateLabelRequest = {
	label: string;
	color: string;
};

export type UpdateLabelRequest = {
	label?: string;
	color?: string;
};
